var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-gray-light"},[_c('div',{staticClass:"grid gap-3 px-2 my-4 lg:max-w-5xl sm:px-6"},[_c('Breadcrumbs',{attrs:{"crumbs":_vm.crumbs}}),_c('SystemInfo',{attrs:{"helpLink":'https://ajuda.sie.sc.gov.br/categorias-artigos/linhas/',"alerts":_vm.alerts}}),_c('UpdateInfo',{attrs:{"updates":_vm.updates}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }